module.exports = __webpack_public_path__ + "static/media/logox.e21d4147.png";